const parseDate = {
  methods: {
    parseDate(date) {
      if (!date) return null

      return `${`${date.getFullYear()}`.padStart(2, 0)}-${`${
        date.getMonth() + 1
      }`.padStart(2, 0)}-${`${date.getDate()}`.padStart(2, 0)}`
    },
  },
}
const date2br = {
  filters: {
    date2br(date) {
      if (!date) return '-'
      return new Intl.DateTimeFormat('pt-BR', {
        timeZone: 'UTC',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(new Date(date))
    },
  },
}
const BRString2datetimeIso = {
  methods: {
    BRString2datetimeIso(datetime) {
      if (!datetime) return null
      const [date_part, time_part] = datetime.split(' ')
      const [day, month, year] = date_part.split('/')
      const [hour, minute, second] = time_part ? time_part.split(':') : []
      const date_formated = `${year}-${month}-${day}`
      const time_formated = `${hour || '00'}:${minute || '00'}:${
        second || '00'
      }`
      const datetime_formated = `${date_formated}T${time_formated}`
      return datetime_formated
    },
  },
}
const date2BRstring = {
  methods: {
    date2BRstring(date) {
      if (!date) return null
      return `${`${date.getDate()}`.padStart(2, 0)}/${`${
        date.getMonth() + 1
      }`.padStart(2, 0)}/${`${date.getFullYear()}`.padStart(4, 0)}`
    },
  },
}
const toReal = {
  methods: {
    toReal(value) {
      return Number(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },
  },
}
const parseDatetime = {
  methods: {
    parseDatetime(date) {
      if (!date) return null

      return `${`${date.getDate()}`.padStart(2, 0)}/${`${
        date.getMonth() + 1
      }`.padStart(2, 0)}/${`${date.getFullYear()}`.padStart(
        2,
        0
      )} ${`${date.getHours()}`.padStart(
        2,
        0
      )}:${`${date.getMinutes()}`.padStart(
        2,
        0
      )}:${`${date.getSeconds()}`.padStart(2, 0)}`
    },
  },
}

const toLocaleDateTimeString = (date) => new Date(date).toLocaleString('pt-br')

const seconds2text = (time) => {
  let hours = Math.floor(time / 3600)
  let minutes = Math.floor((time % 3600) / 60)
  let seconds = Math.floor((time % 3600) % 60)
  return hours + 'h' + minutes + 'm' + seconds + 's'
}

const dateAgendamento = {
  methods: {
    dateAgendamento(date) {
      if (!date) return null

      return `${`${date.getDate()}`.padStart(2, 0)}/${`${
        date.getMonth() + 1
      }`.padStart(2, 0)}/${`${date.getFullYear()}`.padStart(
        2,
        0
      )} ${`${date.getHours()}`.padStart(
        2,
        0
      )}:${`${date.getMinutes()}`.padStart(2, 0)}`
    },
  },
}
const iso2br = (date) => {
  if (!date) return 'Não Definida'
  const utcDate = date.endsWith('Z') ? date : date + 'Z'
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(utcDate))
}

const toBrazilianDateTime = (date) => {
    if (!date) return 'Não Definida'
    const utcDate = date.endsWith('Z') ? date : date + 'Z'
    return new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date(utcDate))
}
const toUTCDateTime = (date) => {
  if (!date) return 'Não Definida'
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'UTC',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(date))
}

export {
  parseDate,
  toReal,
  parseDatetime,
  dateAgendamento,
  BRString2datetimeIso,
  date2BRstring,
  date2br,
  iso2br,
  toBrazilianDateTime,
  toUTCDateTime,
  toLocaleDateTimeString,
  seconds2text,
}
